import { render, staticRenderFns } from "./BlueprintAlbumModal.vue?vue&type=template&id=6b72e6a8&"
import script from "./BlueprintAlbumModal.vue?vue&type=script&lang=ts&"
export * from "./BlueprintAlbumModal.vue?vue&type=script&lang=ts&"
import style0 from "./BlueprintAlbumModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports